import { Component } from '@verndale/core';
import { Accordion } from '@verndale/front-end-components';

class Module extends Component {
  constructor(el) {
    super(el);

    new Accordion(document.querySelector('.accordion'),
      {
        selectedAccordion: 1
      });
  }
  setupDefaults() {
    this.dom = {
      trigger: this.el._$$('.accordion__item'),
      triggerExpanded: this.el._$$('.accordion__item--expanded'),
      faqs: this.el._$$('.faqs-container__faqs-divider'),
      faqsContent: this.el._$('.faqs-container__items'),
      $faqAnchorsInHeader: document._$$('.faqs-supporting-column__question')
    };
    this.accordionItemExpanded = 'accordion__item--expanded';
    this.accordionItem = 'accordion__item';

    this.loadContentFaqs();
  }

  loadContentFaqs() {
    const div = document.createElement('div');
    const divQuestions = document.createElement('div');
    let numerLastIndex = 0;
    this.dom.faqs.forEach((faqs, i) => (
      divQuestions.innerHTML = '',
      [...faqs.getElementsByClassName('faqs-container__faqs-question')].forEach((question, i) => (
        divQuestions.innerHTML += `<div class="accordion__item-link">
    <a href="#${question.id}" class="link link--small ">
      <span class="link__label">${this.el.dataset.editMode === 'false' ? question.textContent : question.querySelectorAll('span')[1]?.textContent || ''}</span>
      </a>
      </div>`,
        numerLastIndex = i + 1
      )),
      div.innerHTML = `
        <div role="tablist" aria-label="Sample Tabs" accordion__item faqs-container__item class="accordion__item faqs-container__item" aria-expanded="false">
                <a href="#" role="tab" class="accordion__item-trigger faqs-container__item-trigger" onclick="return false;">
                  <h3 class="accordion__item-title faqs-container__item-title">${faqs.getElementsByClassName('faqs-container__faqs-heading')[0].textContent} (${numerLastIndex})</h3>
                  <span class="accordion__item-icon">
                    <svg viewBox="0 0 14 2" class="accordion__item-icon-minus">
                        <use xlink:href="#minus" />
                    </svg>
                    <svg viewBox="0 0 14 14" class="accordion__item-icon-plus">
                        <use xlink:href="#plus" />
                    </svg>
                  </span>
                </a>
                <div role="tabpanel" class="accordion__item-panel">
                  <div class="accordion__item-content faqs-container__item-content">
                    ${divQuestions.innerHTML}
                  </div>
                </div>
              </div>`,
      this.dom.faqsContent.innerHTML += div.innerHTML
    ))
  }

  addListeners() {
    this.dom.trigger._on('click', this.handleClick.bind(this));
    this.dom.$faqAnchorsInHeader._on('click', this.closeHeaderPanel.bind(this));
  }

  handleClick(e) {
    if (e.currentTarget.classList.contains(this.accordionItemExpanded)) {
      e.currentTarget.classList.remove(this.accordionItemExpanded)
      e.currentTarget.classList.add(this.accordionItem);
    } else {
      e.currentTarget.classList.remove(this.accordionItem)
      e.currentTarget.classList.add(this.accordionItemExpanded);
    }
  }

  closeHeaderPanel(e) {
    const event = new Event('closeheader');
    document.dispatchEvent(event);
  }
}

export default Module;
